// strona 404 - błąd „Nie znaleziono strony"

import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ArrowLeft, Compass } from 'react-bootstrap-icons';

import { useAppNavigate } from 'hooks';
import { Button, Container } from 'components/controls';

import styles from 'theme/pages/NoMatch/NoMatch.module.scss';

const NoMatch = () => {
  const navigate = useAppNavigate();
  const { t } = useTranslation();

  return (
    <Container>
      <div className={classnames(styles.componentWrapper, 'StylePath-Pages-NoMatch')}>
        <div className={styles.card}>
          <div className={styles.illustration}>
            <div className={styles.iconRing}>
              <Compass aria-hidden />
            </div>
            <div className={styles.code} aria-label="404">
              <span>4</span>
              <span className={styles.zero}>0</span>
              <span>4</span>
            </div>
          </div>

          <h1 className={styles.title}>
            <Trans>Nie znaleziono takiej strony</Trans>
          </h1>
          <p className={styles.subtitle}>
            <Trans>
              Przepraszamy, nie możemy znaleźć strony, której szukasz. Mogła zostać usunięta,
              przeniesiona albo nigdy nie istniała.
            </Trans>
          </p>

          <div className={styles.actions}>
            <Button onClick={() => navigate('/')}>
              <ArrowLeft className={styles.buttonIcon} />
              <span>{t('Powrót do strony głównej')}</span>
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NoMatch;
